import type { Dispatch } from '@reduxjs/toolkit'

import { GRAPH_TAG_TYPES, graphApi } from '../graph/graph-api'
import { PLANT_VIEWER_TAG_TYPES, plantViewerApi } from '../plant/plant-viewer-api'

/** Refetch every cache derived from the active branch's graph data. */
export function invalidateGraphData(dispatch: Dispatch): void {
  dispatch(graphApi.util.invalidateTags([...GRAPH_TAG_TYPES]))
  invalidatePlantViewerData(dispatch)
}

/** Refetch Plant Viewer caches after graphApi already invalidated its own tags. */
export function invalidatePlantViewerData(dispatch: Dispatch): void {
  dispatch(plantViewerApi.util.invalidateTags([...PLANT_VIEWER_TAG_TYPES]))
}
